<template>
  <transition name='fade'>
    <div
      class="modal headimg_box"
      v-if='visible'
    >
      <div
        class="headimg"
        v-loading='insertLoading'
        element-loading-text="图片压缩中，请稍后……"
      >
        <div class="title msp_icon_close">
          <span
            class="title_name"
            v-if='operateType=="addHeadimg"'
          >添加头图</span>
          <span
            class="title_name"
            v-if='operateType=="addHeadimg"'
            style="color:#fd4a4a;margin-left:12px;"
          >(添加成功后可点击头图进行裁剪，头图裁剪比例建议16:10)</span>
          <span
            class="title_name"
            v-if='operateType=="insertImg"'
          >插入图片</span>

          <span
            class="title_name"
            v-if='operateType=="addAtlPic"'
          >添加图片</span>

          <span
            v-if='(operateType=="insertImg" || operateType == "addAtlPic") && activeName === "fromInsertLocal"'
            class="title_name"
            style="color:#F56969;"
          >（一次上传最多50张图片，每张图片最大为20MB）</span>

          <span
            class="iconfont el-icon-close"
            @click.stop='closeBox()'
          ></span>
        </div>
        <div class="headimg_type">
          <el-tabs
            v-model="activeName"
            type="card"
            @tab-click="handleClick"
          >
            <el-tab-pane
              label="正文选择"
              name="fromContent"
              v-if='operateType=="addHeadimg"'
            >正文选择</el-tab-pane>
            <el-tab-pane
              label="本地上传"
              name="fromLocal"
              v-if='operateType=="addHeadimg"'
            >本地上传</el-tab-pane>

            <el-tab-pane
              label="本地上传"
              name="fromInsertLocal"
              v-if='operateType=="insertImg" || operateType == "addAtlPic"'
            >本地上传</el-tab-pane>

            <el-tab-pane
              label="素材库选择"
              name="fromMaterial"
            >素材库选择</el-tab-pane>

            <el-tab-pane
              label="链接插入"
              name="fromOuterUrl"
              v-if='operateType=="insertImg"'
            >链接插入</el-tab-pane>

          </el-tabs>
        </div>
        <div class="headimg_img">
          <from-content
            v-show="activeName === 'fromContent'"
            :contentImg='contentImg'
            :choiceUrlList='choiceUrlList'
            @choiceCancleImg='choiceCancleImg'
          ></from-content>
          <from-material
            v-show="activeName === 'fromMaterial'"
            :choiceUrlList='choiceUrlList'
            @choiceCancleImg='choiceCancleImg'
          ></from-material>
          <from-local
            v-show="activeName === 'fromLocal'"
            :maxImgLength='maxImgLength'
            :orgUrlList='hasHeaderImg'
            :choiceUrlList='choiceUrlList'
            @choiceCancleImg='choiceCancleImg'
            ref='localUpload'
          ></from-local>

          <insert-local
            ref='insertLocalImg'
            v-show="activeName === 'fromInsertLocal'"
            @setLocalpicToeditor='setPicToeditor'
          ></insert-local>

          <div
            v-show="activeName === 'fromOuterUrl'"
            style='width:100%;'
          >
            <div class="play_linkurl">
              <span>图片链接</span>
              <el-input
                placeholder="请输入播放链接"
                v-model="pictureLinkUrl"
              ></el-input>
            </div>
          </div>

        </div>
        <div
          class="headimg_buttom"
          v-show="activeName !== 'fromInsertLocal'"
        >
          <el-button
            type="primary"
            @click.native='sureAddHeadimg()'
          >确定</el-button>
        </div>

      </div>
    </div>
  </transition>
</template>

<script>

import * as api from '../../../api'
import fromContent from './fromContent'
import fromMaterial from './fromMaterial'
import fromLocal from './fromLocal'
import insertLocal from './insertLocal'
import logsMixins from '../../../mixins/logs'
export default {
  name: 'headimg',
  data () {
    return {
      visible: false,
      activeName: 'fromContent',
      operateType: '',
      contentImg: [],
      hasHeaderImg: [],
      choiceUrlList: [],
      maxImgLength: 3,
      editorIns: '',
      insertLoading: false,
      pictureLinkUrl: ''

    }
  },
  mixins: [logsMixins],
  mounted () {
    this.$root.eventHub.$on('getEveryTypePic', (type, listImg, listHeaderImg, editor) => {
      this.visible = true
      this.operateType = type
      if (type === 'addHeadimg') {
        this.activeName = 'fromContent'
        this.contentImg = listImg
        this.hasHeaderImg = listHeaderImg
      } else if (type === 'insertImg' || type === 'addAtlPic') {
        this.activeName = 'fromInsertLocal'
        this.editorIns = editor
        this.$nextTick(() => {
          this.$refs.insertLocalImg.dragUploadPicture()
          this.getLastFolderChoice()
        })
      }
    })

    this.$root.eventHub.$on('closeVisiblebox', (data) => {
      this.visible = false
    })

  },
  destroyed () {
    this.$root.eventHub.$off('getEveryTypePic')
  },
  components: {
    fromContent,
    fromMaterial,
    fromLocal,
    insertLocal
  },
  computed: {

  },
  methods: {
    closeBox () {
      this.visible = false
    },
    handleClick (tab, event) {

    },
    //选择或取消文章里和素材库里面的图片
    choiceCancleImg (item) {
      if (item) {
        if (this.choiceUrlList.length > 0) {
          var k = 0
          for (var i = 0; i < this.choiceUrlList.length; i++) {
            if (this.activeName === 'fromMaterial') {
              if (!this.choiceUrlList[i].hasOwnProperty('id') || (this.choiceUrlList[i].hasOwnProperty('id') && this.choiceUrlList[i].id !== item.id)) {
                k++
              } else {
                break;
              }
            } else {
              if (this.choiceUrlList[i] !== item) {
                k++
              } else {
                break;
              }
            }
          }
          if (k == this.choiceUrlList.length) {
            if (this.operateType === 'addHeadimg') {
              if (this.choiceUrlList.length >= (this.maxImgLength - this.hasHeaderImg.length)) {
                this.$notify.warning({
                  title: '错误',
                  message: '头图总数已达到三张'
                });

              } else {
                this.choiceUrlList.push(item)
              }
            } else if (this.operateType === 'insertImg' || this.operateType === 'addAtlPic') {
              this.choiceUrlList.push(item)
            }
          }
          else {
            if (this.activeName === 'fromMaterial') {
              for (var j = 0; j < this.choiceUrlList.length; j++) {
                if (this.choiceUrlList[j].hasOwnProperty('id')) {
                  if (this.choiceUrlList[j].id == item.id) {
                    this.choiceUrlList.splice(j, 1)
                  }
                }
              }
            } else {
              for (var j = 0; j < this.choiceUrlList.length; j++) {
                if (this.choiceUrlList[j] == item) {
                  this.choiceUrlList.splice(j, 1)
                }
              }
            }
          }
        } else {
          if (this.operateType === 'addHeadimg') {
            if (this.maxImgLength == this.hasHeaderImg.length) {
              this.$notify.warning({
                title: '错误',
                message: '头图总数已达到三张'
              });
            } else {
              this.choiceUrlList.push(item)
            }
          } else if (this.operateType === 'insertImg' || this.operateType === 'addAtlPic') {
            this.choiceUrlList.push(item)
          }
        }
      }
    },
    sureAddHeadimg () {
      if (this.operateType === 'addHeadimg') {
        var arr = []
        arr = arr.concat(this.hasHeaderImg).concat(this.choiceUrlList)
        var lastArr = []
        for (var i = 0; i < arr.length; i++) {
          var currentUrl = ''
          if (!arr[i].hasOwnProperty('id')) {
            currentUrl = arr[i]
          } else if (arr[i].hasOwnProperty('id')) {
            currentUrl = arr[i].url
          }
          lastArr.push(currentUrl)
        }
        this.$root.eventHub.$emit('setHeadimg', lastArr)
        this.visible = false
      } else if (this.operateType === 'insertImg') {
        if (this.activeName === 'fromOuterUrl') {
          if (this.pictureLinkUrl) {
            this.editorIns.insertImages([{ url: this.pictureLinkUrl, size: null, title: '' }])
            this.visible = false
          } else {
            this.$notify.info({
              title: '提示',
              message: '请输入图片链接'
            })
          }
        } else {
          var imgArr = []
          for (var i = 0; i < this.choiceUrlList.length; i++) {
            imgArr.push(this.choiceUrlList[i].id)
          }
          var option = {
            ...this.$store.getters.baseOption,
            "params": {
              ids: imgArr
            }
          }
          this.insertLoading = true
          api._post(_IMGFILEURL_ + 'picture/snapshot/title', option).then((resp) => {
            if (resp.code == 200) {
              if (resp.data) {
                var currentInsertObj = []
                for (var j = 0; j < resp.data.length; j++) {
                  currentInsertObj.push({ url: resp.data[j].url, size: null, title: resp.data[j].title })
                }
                this.editorIns.insertImages(currentInsertObj)
              }
              this.visible = false
            }
            this.insertLoading = false
          }).catch((error) => {
            console.log(error)
            this.insertLoading = false
          })
        }
      } else if (this.operateType === 'addAtlPic') {
        var currentData = []
        for (var j = 0; j < this.choiceUrlList.length; j++) {
          currentData.push({
            url: this.choiceUrlList[j].origin_url,
            mark: ''
          })
        }
        this.$root.eventHub.$emit('addAtlPicModel', currentData)
        this.visible = false
      }
    },
    setPicToeditor (data) {
      this.choiceUrlList = data
      this.sureAddHeadimg()
    }
  },
  watch: {
    visible () {
      if (this.visible == false) {
        this.choiceUrlList = []
        this.$refs.localUpload.clearData()
        this.$refs.insertLocalImg.clearUploadData()
      }
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='stylus' scoped>
.headimg_box
  .headimg
    position relative
    width 796px
    height 700px
    border-radius 6px
    background #fff
    .title
      clear both
      box-sizing border-box
      padding 0 14px 0 14px
      height 50px
      .title_name
        span-medium-title()
        float left
        line-height 50px
      .iconfont
        float right
        font-size 22px
        line-height 50px
        cursor pointer
    .headimg_type
      height 38px
      border-top 1px solid #E6E7EB
      background #F0F1F3
    .headimg_img
      height 612px
    .headimg_buttom
      position absolute
      right 20px
      bottom 20px
      box-sizing border-box
      border-radius 0 0 6px 6px
      button
        width 74px
        height 28px
        center()
        line-height 0
    .play_linkurl
      display flex
      box-sizing border-box
      margin-top 30px
      padding-right 30px
      padding-left 30px
      width 100%
    .play_linkurl span
      display inline-block
      width 90px
      line-height 40px
</style>
